
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserFlag } from '~/interfaces/user.interface';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';

@Component
export default class FlagsSelector extends Vue {
    @Prop({ default: () => [] }) selectedFlagIds!: string[];
    @Prop({ default: false }) isDisabled!: boolean;

    selectedFlag: string | null = null;

    get availableFlags(): UserFlag[] {
        return RemoteFeatureFlagsModule.availableFlags.filter(
            (flag) => !this.selectedFlagIds.includes(flag.id),
        );
    }

    get selectedFlags(): UserFlag[] {
        return RemoteFeatureFlagsModule.availableFlags.filter(
            (flag) => this.selectedFlagIds.includes(flag.id),
        );
    }

    addFlag() {
        if (this.selectedFlag) {
            this.$emit('addFlag', this.selectedFlag);
        }
    }

    removeFlag(flagId: string) {
        this.$emit('removeFlag', flagId);
    }
}
